import { SELECT_DEALER } from 'constants/ActionTypes';
import * as types from 'modules/hardwares/actionTypes';
import type {
  DeleteHardwareFromDealerSuccessAction,
  FetchHardwaresSuccessAction,
  LinkHardwareSuccessAction,
} from 'modules/hardwares/types';
import { uniq } from 'utils/ObjectUtils';
import { createReducer } from 'utils/ReduxUtils';

type State = Array<string>;

const initialState: State = [];

const add = (state: State, { payload }: LinkHardwareSuccessAction): State => uniq([payload.hardwareId, ...state]);

const deleteOne = (state: State, { payload }: DeleteHardwareFromDealerSuccessAction): State =>
  state.filter(id => id !== payload);

const update = (state: State, { payload }: FetchHardwaresSuccessAction): State =>
  uniq([...state, ...payload.content.map(({ hardwareId }) => hardwareId)]);

const clear = (): State => [];

export default createReducer(initialState, {
  [types.LINK_HARDWARE_SUCCESS]: add,
  [types.FETCH_HARDWARES_SUCCESS]: update,
  [types.DELETE_HARDWARE_SUCCESS]: deleteOne,
  [types.RESET_HARDWARES_DASHBOARD]: clear,
  [SELECT_DEALER]: clear,
  [types.SET_HARDWARES_DASHBOARD_FILTERS]: clear,
  [types.SET_HARDWARES_DASHBOARD_FILTER]: clear,
  [types.REMOVE_HARDWARES_DASHBOARD_FILTER]: clear,
});
